import React, { useState, useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
import styles, {
  StyledIcon,
  StyledOpenShifts,
  StyledMainColumn,
  StyledIconsContainer
} from "~/src/containers/scheduler/OpenShifts/OpenShiftTableRow/table-row.styles";
import { iconNew } from "@teamrota/rota-design";
import WeeklyView from "./WeeklyView/weekly-view";
import DailyView from "./DailyView/daily-view";

const { Sun, Moon } = iconNew;

const OpenShiftTableRow = ({
  schedule,
  onPressShiftCell,
  onPressGridCell,
  showCancelledShifts,
  selectedDayIndex,
  setSelectedDayIndex,
  assignMemberLoading
}) => {
  const [unassignedShifts, setUnassignedShifts] = useState([]);

  useEffect(() => {
    if (showCancelledShifts) {
      setUnassignedShifts(schedule?.unassignedShifts);
    }
    if (!showCancelledShifts) {
      setUnassignedShifts(
        schedule?.unassignedShifts?.map(({ date, shifts }) => ({
          date,
          shifts: [...shifts.filter(shift => !shift?.cancelledAt)]
        }))
      );
    }
  }, [schedule, showCancelledShifts]);

  useEffect(() => {
    if (unassignedShifts?.length > 0) {
      const shifts = [];
      unassignedShifts?.forEach(shift => {
        shifts.push(shift);
      });
    }
  }, [unassignedShifts]);

  const getInitialShiftData = (rowDayIndex, startTime) => {
    onPressGridCell({
      startTime
    });
  };

  const getFifteenMinsInFuture = date => {
    const hour = moment().hour();
    const minute = moment().minute();
    return moment(date).set({
      hour: parseInt(hour, 10),
      minute: parseInt(minute + 15, 10)
    });
  };

  const isWeeklyView = selectedDayIndex === null;
  const isDailyView = !isWeeklyView;

  return (
    <StyledOpenShifts isWeeklyView={isWeeklyView}>
      <StyledMainColumn isDailyView={isDailyView}>
        <StyledIcon name="CLOCK_SCHEDULER" size="LARGE" />
        <p style={styles.title}>Open shifts</p>
        {isDailyView && (
          <StyledIconsContainer>
            <Sun /> <Moon />
          </StyledIconsContainer>
        )}
      </StyledMainColumn>

      {isWeeklyView && (
        <WeeklyView
          setSelectedDayIndex={setSelectedDayIndex}
          unassignedShifts={unassignedShifts}
          onPressShiftCell={onPressShiftCell}
          getInitialShiftData={getInitialShiftData}
          getFifteenMinsInFuture={getFifteenMinsInFuture}
        />
      )}

      {isDailyView && (
        <DailyView
          selectedDayIndex={selectedDayIndex}
          setSelectedDayIndex={setSelectedDayIndex}
          unassignedShifts={unassignedShifts}
          onPressShiftCell={onPressShiftCell}
          getInitialShiftData={getInitialShiftData}
          getFifteenMinsInFuture={getFifteenMinsInFuture}
          assignMemberLoading={assignMemberLoading}
        />
      )}
    </StyledOpenShifts>
  );
};

const mapStateToProps = s => ({
  showCancelledShifts: s.scheduler?.showCancelledShifts
});

export default connect(mapStateToProps)(OpenShiftTableRow);
